export const CATEGORY_IMAGE_MAP = {
  'Alma de la Fiesta': '/assets/categorias/Alma_de_la_fiest.webp',
  'Clásico Auténtico': '/assets/categorias/Clásico.webp ',
  'Sofisticado': '/assets/categorias/Sofisticado.webp',
  'Explorador': '/assets/categorias/Explorador.webp',
  'Elegante': '/assets/categorias/Connoisseur.webp',
  'Relajado': '/assets/categorias/Relajado.webp',
  'Sociable': '/assets/categorias/Social.webp',
  'Reservado': '/assets/categorias/Reservado.webp',
  'Agradable': '/assets/categorias/Agradable.webp',
  'Apasionado': '/assets/categorias/Apasionado.webp',
  'Equilibrado': '/assets/categorias/Equilibrado.webp',
  'Carpe Diem': '/assets/categorias/CarpeDiem.webp ',
  'Paciente': '/assets/categorias/Paciente.webp ',
  'Atrevido': '/assets/categorias/Atrevido.webp ',
  'Accesible': '/assets/categorias/Accesible.webp ',
  'Creativo': '/assets/categorias/Creativo.webp ',
  'Impulsivo': '/assets/categorias/Impulsivo.webp ',
  'Paciencia': '/assets/categorias/Paciente.webp ',
}
